<template>
  <!-- Navbar menu Starts -->
  <nav class="navbar-default navbar-octopus navbar-static-side" role="navigation">
    <!-- Sidebar Starts -->
    <div class="sidebar-collapse-octopus sidebar-collapse padding_bot_500">
      <!-- Sidebar ul Starts -->
      <ul class="octopus-nav nav" id="octopus-menu" ref="octopus-menu">
        <!-- User Logo & User Dropdown li Starts -->
        <li class="nav-header">
          <!-- company logo span Starts -->
          <span class="company-logo">
            <!-- Company Logo Starts -->
            <div class="nav-preview-company-logo">
              <!-- Company Logo or Default Logo If fails Starts -->
              <img class="img-responsive nav-company-logo"
                   v-if="(company || {}).company_logo"
                   v-show="!loading" :src="logoBucket + company.company_logo"
                   @error="replaceLogoByDefault" alt="logo"/>
              <!-- Company Logo or Default Logo If fails Ends -->

              <div v-if="loggedUserRole === 'account_admin' || loggedUserRole === 'super_admin'">
                <button style="display:none" title="change company logo"
                        data-toggle="dropdown" class="btn btn-xs dropdown-toggle company-button">
                  <i class="fa fa-camera"></i>
                </button>
                <div class="nav-preview-company-logo-loader" style="display: none;">
                  <img class="img-responsive" src="/pic/loading-4.gif" alt="loading"/>
                </div>
              </div>

            </div>
            <!-- Company Logo Ends -->

            <!-- Change Company Logo Form Starts -->
            <form method="POST" id="imgcompany" enctype="multipart/form-data"
                  :action="imageCompanyAction">
                <span style="display:none" class="span_file_input">
                    change company logo
                  <input name="profile_picture" type="file" style=""
                         id="company_upload_pic"
                         accept="image/*, image/x-png, image/jpg, image/jpeg"/>
                </span>
            </form>
            <!-- Change Company Logo Form Ends -->
          </span>
          <!-- company logo span Ends -->
          <div class="home-profile" v-if="configCdnEnv">
            <a data-toggle="dropdown" class="dropdown-toggle uniq_flex" href="#">
              <span id="myaccount-image">
                <div v-if="loggedUserRole === 'customer'">
                  <img class="img-responsive" v-if="customer.avatar"
                       :src="configCdnEnv.trim(' ') + configS3UserPictureMedium.trim(' ') + customer.avatar.trim(' ')"/>
                </div>
                <div v-else>
                  <img class="img-responsive" v-if="user.avatar"
                       :src="configCdnEnv.trim(' ') + configS3UserPictureMedium.trim(' ') + user.avatar.trim(' ')"/>
                </div>
              </span>

              <span class="block m-t-xs  dis_none_in_mob" style="margin-left:10px;color:#0f0f0f;">
                <div style="margin-top:5px;padding-top:10px;">
                  <span v-if="user.username">{{ capitalizeFirstLetter(user.username).split(' ')[0] }}</span>
                  <br/>{{ role.view_role_name }} <span class="fa fa-angle-down"></span>
                </div>
              </span>
            </a>
            <ul class="dropdown-menu user-dropdown">
              <li v-if="loggedUserRole === 'customer'">
                <a :href="links['myAccountCustomer']">
                  My Account
                </a>
              </li>
              <li v-else>
                <a :href="links['myAccount']">
                  My Account
                </a>
              </li>
              <li v-if="loggedUserRole !== 'customer'">
                <a :href="links['internalMessages']"
                   class="contractor_a_link"> My Messages</a>
              </li>
              <li>
                <a :href="links['changePassword']"
                   class="contractor_a_link">Change My Password</a>
              </li>
              <li v-if="generalContractor.user_id !== user.user_id">
                <a :href="links['changeEmail']"
                   class="contractor_a_link">Change My Email</a>
              </li>
              <li v-if="links['switchToAdmin']">
                <a :href="links['switchToAdmin']"
                   class="contractor_a_link">Switch To Admin</a>
              </li>
              <li class="divider"></li>
              <li>
                <a :href="links['Logout']">
                  <i class="fa fa-power-off"></i><span> Log out</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        <!-- User Logo & User Dropdown li Ends -->

        <!-- Getting Started Menu Link Starts -->
        <li v-if="loggedUserRole !== 'customer' && loggedUserRole !== 'contractor' && links" class="for-dashboard">
          <a :href="links['gettingStarted']">
            <span class="nav-label">
                Getting Started
            </span>
          </a>
        </li>
        <!-- Getting Started Menu Link Ends -->

        <!-- Dashboard Menu Link Starts-->
        <li v-if="loggedUserRole !== 'customer' && loggedUserRole !== 'contractor' && links" class="for-dashboard">
          <a :href="links['redesignDashboard']">
            <i class="fa fa-tachometer"></i>
            <span class="nav-label">
              Dashboard
            </span>
          </a>
        </li>
        <!-- Dashboard Menu Link Ends-->

        <!-- Menu Items Starts -->
        <li v-for="(item,key) in items" :data-target="key" :key="key"
            :class="{'initial-active':currentUrl.includes(item.base) }" v-show="item.authorized">

          <!-- Menu Item Link Starts -->
          <a :href="item.url" :id="item.countId" class="unique_box_number"
             @click="loadItemNumbers($event,item.active)"
             :class="{'has-arrow': !Array.isArray(item.items)}" :aria-expanded="false">

            <i :class="item.icon"></i>

            <span class="nav-label" @click="loadItemNumbers($event)">
              {{ item.text }}
              <span v-if="counts[key] && counts[key][item.countId]"
                    :class="['pull-right label label-'+counts[key][item.countId].color]">
                {{ counts[key][item.countId].count }}
              </span>
            </span>

          </a>
          <!-- Menu Item Link Ends -->

          <!-- Menu Item List of Links Starts -->
          <ul class="nav nav-second-level for-dashboard" style="height: auto !important;">
            <li v-if="item.button && item.button.authorized"  class="menu-button" >
              <a :href="item.button.url"
                 :data-toggle="item.button.dataToggle"
                 :data-target="item.button.dataTarget"
                 :onclick="item.button.onClick"
                 class="btn btn-outline btn-primary">
                <span class="fa fa-plus hidden-sm hidden-xs"></span> {{ item.button.text }}
              </a>
            </li>

            <!-- Level 1 Item Links Starts -->
            <li v-for="(child,page) in item.items"
                v-if="child.authorized && key != 'customers' || child.authorized && key == 'customers' && !isSubMenu"
                :key="page" class="for-dashboard">
              <a :id="child.countId"
                 :href="child.items ? '#' : (child.url.includes('http') ? child.url : item.base + child.url)"
                 :class="{'has-arrow':child.items}">
                {{ page }}
                <span v-if="child.countId && counts[key] && counts[key][child.countId]"
                      :class="['pull-right label label-'+counts[key][child.countId].color]">{{
                    counts[key][child.countId].count
                  }}
                </span>
              </a>

              <div v-if="child.spacer" class="spacer"></div>
              <ul class="nav nav-third-level" v-if="child.items">
                <li v-for="(grandchild,page) in child.items" v-if="grandchild.authorized" :key="page"
                    class="for-dashboard">
                  <a :id="grandchild.countId"
                     :href="grandchild.url.includes('http') ? grandchild.url : child.base + grandchild.url">
                    {{ page }}
                    <span v-if="grandchild.countId && counts[key] && counts[key][grandchild.countId]"
                          :class="['pull-right label label-'+counts[key][grandchild.countId].color]">{{
                        counts[key][grandchild.countId].count
                      }}
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <!-- Level 1 Item Links Ends -->


          </ul>
          <!-- Menu Item List of Links Ends -->
        </li>
        <!-- Menu Items Ends -->

      </ul>
      <!-- Sidebar ul Ends -->
    </div>
    <!-- Sidebar Ends -->
  </nav>
  <!-- Navbar menu Ends -->
</template>

<script>

import {getItemNumbersCount, getSideMenu} from '@/modules/Layout/api'
import metismenu from "metismenu";

export default {
  name: "octopus-sidebar",
  props: {
    currentUrl: {
      default: ''
    },
    isSubMenu: {
      default: null
    }
  },
  data() {
    return {
      counts: {
        booking: {},
        inquiry: {},
        estimates: {},
        invoices: {},
        customers: {},
        complaint: {}
      },
      role: null,
      company: null,
      customer: null,
      links: null,
      items: null,
      user: null,
      generalContractor: null,
      logoBucket: null,
      configCdnENV: null,
      configS3UserPictureMedium: null,
      imageCompanyAction: null,
      loggedUserRole: null,
      configCdnEnv: null,
      loaded: false,
      loading: false,
      metismenu: null
    }
  },
  methods: {
    loadMenu() {
      getSideMenu().then(response => {
        this.role = response.data.role;
        this.company = response.data.company;
        this.customer = response.data.customer;
        this.links = response.data.links;
        this.items = response.data.items;
        this.user = response.data.user;
        this.generalContractor = response.data.generalContractor;
        this.logoBucket = response.data.logoBucket;
        this.configCdnEnv = response.data.CONFIG_CDN_ENV;
        this.configS3UserPictureMedium = response.data.CONFIG_S3_USER_PICTURE_MEDIUM;
        this.imageCompanyAction = response.data.IMAGE_COMPANY_ACTION;
        this.loggedUserRole = response.data.loggedUserRole;
        this.showGmailTab = response.data.showGmailTab;
        this.showCalendarTab = response.data.showCalendarTab;
        this.showBillingInfoCondition = response.data.showBillingInfoCondition;


        if (response.data.loadTidoScript) {
          this.loadTidioScript()
        }

        this.loaded = true
        this.$nextTick(() => {
          this.metismenu = new metismenu('#octopus-menu', {toggle: false});
          // this.$refs['octopus-menu'].querySelector(':scope > .active > a').click()
          // this.$refs['octopus-menu'].querySelector(':scope > .active > .unique_box_number').trigger('click')
          // this.loadCounts(this.$refs['octopus-menu'].querySelector(':scope > .active').getAttribute('data-target'))
        })
      })
    },
    loadCounts(type) {
      if (
          type === 'recently-updated' ||
          type === 'awaitingAccept-booking' ||
          type === 'unapproved-booking' ||
          type === 'awaitingUpdate-booking'
      ) {
        type = 'booking';
      }

      if (type === 'refund' || type === 'payment') {
        type = 'invoices';
      }
      let vm = this;
      this.loading = true;

      if (type === 'booking') {
        Promise.allSettled([
          getItemNumbersCount({type}),
          getItemNumbersCount({type: 'booking1'})]
        ).then((responses) => {
          for (let response of responses) {
            if (response.status === 'fulfilled') {
              vm.counts[type] = Object.assign({}, vm.counts[type], response.value.data)
              vm.loading = false
            }
          }
        })
        return true
      }

      getItemNumbersCount({type})
          .then(function (response) {
            vm.counts[type] = response.data
            vm.loading = false
          })
    },
    loadTidioScript() {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', '//code.tidio.co/me94encvtkpike5pmqnvv5h6fbdgyjax.js')
      document.head.appendChild(recaptchaScript)
    },
    loadItemNumbers(event) {
      let vm = this;
      let li = event.target.closest('li[data-target]').closest('li[data-target]')
      let type = li.getAttribute('data-target')
      let initialActiveLi = this.$refs['octopus-menu'].querySelector('.initial-active')

      if (initialActiveLi) {
        initialActiveLi.classList.remove('initial-active')
      }

      if (this.isEmptyObject(this.counts[type]) && !this.loading) {
        this.loadCounts(type);
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    replaceLogoByDefault(e) {
      e.target.src = "/pic/octlogo.png"
    },
    isEmptyObject(obj) {
      for (let prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          return false;
        }
      }
      return JSON.stringify(obj) === JSON.stringify({});
    }
  },
  mounted() {
    this.loadMenu()
    $(document).ready(function () {
      let menu = document.querySelector('.navbar-octopus ul li.active')
      if (menu) {
        menu.classList.remove('active')
      }
    })
  }
}
</script>

<style scoped>
@import "metismenu/dist/metisMenu.min.css";

.navbar-octopus {
  z-index: 1005;
  background-color: #2f4050;
  height: 1450px;
}

.sidebar-collapse-octopus {
  background-color: #2f4050;
}

.octopus-nav {
  background-color: #2f4050
}

.nav-company-logo {
  position: relative;
}

.nav-preview-company-logo {
  position: relative;
}

.company-button {
  position: absolute;
  top: 20px;
  right: 9px;
  border-radius: 50% !important;
  font-size: 19px;
  padding: 3px 7px !important;
  background-color: #fff;
  border: 1px solid #18a689;
}

.nav-preview-company-logo-loader {
  top: 30px;
  right: 35px;
}

.menu-button {
  padding: 10px;
}

.menu-button a {
  padding: 6px 10px 6px 10px;
}

.initial-active {
  border-left: 4px solid #c5ced6;
  background: #293846;
}

.mm-active {
  border-left: 4px solid #c5ced6;
  background: #293846;
}

.user-dropdown {
  margin-top: 0px;
}

.nav-third-level {
  padding-left: 15px;
  border-left: 0;
}

.nav-second-level .mm-active {
  border-left: 0;
}

.spacer {
  margin-top: 6px;
  margin-bottom: 12px;
  border: 0;
  border-top: 1px solid #4d6377;
}

@media only screen and (max-width: 768px) {
  .nav-label .label {
    margin-right: 15px !important;
    margin-top: 15px !important;
  }

  .mm-collapse:not(.mm-show) {
    display: none !important;
  }

  body.mini-navbar .nav-header {
    padding: unset;
  }

  .nav-header {
    padding: 32px 25px 33px !important;
  }
}

#octopus-menu {
  z-index: 99999 !important;
}

.nav-company-logo {
  border: 0;
  width: 80px;
}

.mini-navbar .metismenu .has-arrow::after {
  width: 0;
  height: 0;
  display: none;
}
</style>
